import { SearchTypeEnum, UpdateImportBulkInput, UpdateImportInput } from '@/models/gen/graphql';

import { UpdateAddonImportBulkDocument } from '@/api/queries';
import graphApi from '@/api';

const [runUpdateImportBulk] = graphApi(UpdateAddonImportBulkDocument);

const unarchiveAddonImports = async (importIds: string[]) => {
  const updates: UpdateImportInput[] = importIds.map(
    (id: string): UpdateImportInput => ({
      query: [
        {
          id: [
            {
              type: SearchTypeEnum.Or,
              values: [id],
            },
          ],
        },
      ],
      value: {
        archivedAt: [null],
      },
    })
  );

  const input: UpdateImportBulkInput = {
    updates,
  };

  const res = await runUpdateImportBulk({ input });
  return res?.updateImportBulk;
};

export default unarchiveAddonImports;
